module.exports = require('./helpers/bundle-url').getBundleURL('8aiQJ') + "frame-17.f0731216.svg";